// Copyright (c) 2024. UpCircle Technology AG.
// All rights reserved. Redistribution in source and/or binary forms,
// with or without modification, is not permitted.
import React from 'react';
import Slider from '@mui/material/Slider';
import './Slider.scss';

export default function SliderInput({
  value,
  onChange = () => {},
  onChangeCommitted = () => {},
  min = 0,
  max = 1,
  step = 0.01,
  marks = [],
  ...rest
}) {
  const [valueInternal, setValueInternal] = React.useState(value ?? 0.5);

  React.useEffect(() => {
    setValueInternal(value ?? 0.5);
  }, [value]);

  // Handler to intercept arrow key events
  const handleKeyDown = (e) => {
    if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(e.key)) {
      e.preventDefault(); // Prevent slider from updating its value
    }
  };

  function handleChange(e, newValue) {
    setValueInternal(newValue);
    onChange(newValue);
  }

  const sliderValue = Math.round((valueInternal ?? 0.5) * 100);

  return (
    <div className='slider-input'>
      <div className='slider-container'>
        <Slider
          className={`quality-slider ${value === undefined ? 'disabled' : ''}`}
          value={valueInternal}
          min={min}
          max={max}
          step={step}
          marks={marks}
          onChange={handleChange}
          onChangeCommitted={(e, newValue) => onChangeCommitted(newValue)}
          onKeyDown={handleKeyDown}
          valueLabelDisplay='off'
          {...rest}
        />
        <span className='slider-value'>{sliderValue}%</span>
      </div>
    </div>
  );
}
